var React = require('react');

function OpenInNew (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.3333 8C12.9651 8 12.6667 8.29848 12.6667 8.66667V12.6667H3.33333V3.33333H7.33333C7.70152 3.33333 8 3.03486 8 2.66667C8 2.29848 7.70152 2 7.33333 2H3.3317C2.59571 2 2 2.59722 2 3.33324V12.6668C2 13.4045 2.59657 14 3.33324 14H12.6668C13.4042 14 14 13.4045 14 12.6683V8.66667C14 8.29848 13.7015 8 13.3333 8ZM6.4714 10.4714L12.6667 4.27614V6C12.6667 6.36819 12.9651 6.66667 13.3333 6.66667C13.7015 6.66667 14 6.36819 14 6V2.66667C14 2.29848 13.7015 2 13.3333 2H10C9.63181 2 9.33333 2.29848 9.33333 2.66667C9.33333 3.03486 9.63181 3.33333 10 3.33333H11.7239L5.5286 9.5286C5.26825 9.78895 5.26825 10.2111 5.5286 10.4714C5.78895 10.7318 6.21106 10.7318 6.4714 10.4714Z","fill":"#1C232B"}));
}

OpenInNew.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = OpenInNew;

OpenInNew.default = OpenInNew;
